
















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Type } from "modules/contact/models/message";

const contactStore = namespace("contact");

@Component
export default class ContactButton extends Vue {
  @contactStore.Mutation private open!: (type: Type) => void;

  private type: Type = Type.relationProfile;
}
